import React, { lazy, Suspense } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useStoreUrl } from '../contexts/StoreBootstrap';
import { CartItem, User } from '../App';

const WheelAdvisorChat = lazy(() => import('../components/WheelAdvisorChat'));

interface StoreLayoutProps {
    children: React.ReactNode;
    cart: CartItem[];
    currentUser: User | null;
    onLogout: () => void;
    felgusEnabled?: boolean;
}

const StoreLayout: React.FC<StoreLayoutProps> = ({ children, cart, currentUser, onLogout, felgusEnabled = true }) => {
    const isProductsPage = useStoreUrl().pathname === '/products';
    
    return (
        <div className="fc-store w-full min-h-screen bg-[#f7f8f5] text-[#0d0d0d]">
            <Header 
                cartCount={cart.reduce((sum, item) => sum + item.quantity, 0)} 
                currentUser={currentUser}
                onLogout={onLogout}
            />
            {/* Top Store Trust & Benefit Strip */}
            <div className="fc-trust-strip hidden sm:block w-full bg-[#0d121f] border-b border-cyan-900/30 text-gray-300 py-2 px-3 text-[11px] sm:text-xs">
                <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-center">
                    <div className="flex items-center justify-center gap-1.5">
                        <span className="text-emerald-400 font-bold">🛡️</span>
                        <span><strong>Dobór felg pod samochód:</strong> pomoc w prawidłowym dopasowaniu</span>
                    </div>
                    <div className="flex items-center justify-center gap-1.5">
                        <span className="text-cyan-400 font-bold">⭐</span>
                        <span><strong>Autoryzowany dystrybutor:</strong> 100% oryginalne felgi od producenta</span>
                    </div>
                    <div className="flex items-center justify-center gap-1.5">
                        <span className="text-amber-400 font-bold">📦</span>
                        <span><strong>Bezpieczna wysyłka:</strong> ubezpieczony kurier DPD</span>
                    </div>
                </div>
            </div>
            <main className={`w-full ${isProductsPage ? 'px-1 xs:px-2 sm:px-3 md:px-4' : 'px-2 xs:px-3 sm:px-4 md:px-6 lg:px-8'} safe-area-inset-left safe-area-inset-right`}>
                {children}
            </main>
            <Footer />
            {felgusEnabled && (
                <Suspense fallback={null}>
                    <WheelAdvisorChat user={currentUser} />
                </Suspense>
            )}
        </div>
    );
};

export default StoreLayout;
